import { NavItem } from 'common/HorizontalNavPage';
import { SOURCING_SETTINGS_TABS } from './Tabs.types';
import { useStaticPermissions } from 'common/auth/Authorize';
import { useSourcingIntl } from './translations/useSourcingIntl';
import { OcDarklyFlags, useOcDarklyBoolean } from '@oc/darkly/oc';

export const useNavItems = (): NavItem[] => {
  const intl = useSourcingIntl();
  const staticPermissions = useStaticPermissions();
  const supplierGroupPermissions = staticPermissions({ permissionName: 'SUPPLIER_GROUP' });
  const { jobPostingSeniority } = useOcDarklyBoolean(OcDarklyFlags.BooleanFlag.jobPostingSeniority);

  const navItems: NavItem[] = [
    {
      label: intl.jobApplicationStages,
      path: SOURCING_SETTINGS_TABS.JOB_APPLICATION_STAGES,
      'data-test': 'job_application_stages_tab',
      permissions: [{ name: 'JOB_APPLICATION_STAGE', action: 'READ' }]
    }
  ];

  const supplierGroupingTab: NavItem = {
    label: intl.supplierGroups,
    path: SOURCING_SETTINGS_TABS.SUPPLIER_GROUPS,
    permissions: [],
    'data-test': 'supplier-groups__settings__tab'
  };

  const senioritiesTab: NavItem = {
    label: intl.seniority,
    path: SOURCING_SETTINGS_TABS.SENIORITY,
    permissions: [],
    'data-test': 'seniorities_tab'
  };

  const supplierGroupingTabIndex = navItems.findIndex((item) => item.label === supplierGroupingTab.label);
  const senioritiesTabIndex = navItems.findIndex((item) => item.label === senioritiesTab.label);

  if (supplierGroupPermissions.READ) {
    if (supplierGroupingTabIndex === -1) navItems.push(supplierGroupingTab);
  } else {
    if (supplierGroupingTabIndex !== -1) navItems.splice(supplierGroupingTabIndex, 1);
  }

  if (jobPostingSeniority) {
    if (senioritiesTabIndex === -1) navItems.push(senioritiesTab);
  } else {
    if (senioritiesTabIndex !== -1) navItems.splice(senioritiesTabIndex, 1);
  }

  return navItems;
};
